<div class="main">
  @if(isLoading) {
  <app-loading></app-loading>
  } @else { @if (errorMessage !== null) {
  <f-alert in-container variant="error" class="column-12">
    <p>{{ errorMessage }}</p>
  </f-alert>
  }
  <div *ngIf="subscribeItem">
    <app-schedule-subscription
      [subscribeItem]="subscribeItem"
      (clearSubscribeItem)="onClearSubscribeItem()"
    ></app-schedule-subscription>
  </div>
  <div *ngIf="subscribeItem === null">
    <h1>Reports & Dashboards</h1>
    @if (reportBuilderEnabled) {
    <div class="report-builder-entry">
      <f-button text="Build a report" variant="action" (buttonClicked)="openReportBuilder()"></f-button>
    </div>
    }
    @if(shareAlertMessage !== null) {
    <div class="share-alert">
      <f-alert 
        in-container 
        [variant]="shareAlertVariant" 
        class="column-12"
        dismissable
        (alertClosed)="onDismissShareAlert()"
      >
        <p>{{ shareAlertMessage }}</p>
      </f-alert>
    </div>
    }
    
    <!-- Share Confirmation Modal -->
    <app-share-confirmation-modal
      [visible]="showShareModal"
      [reportTitle]="shareReportTitle"
      (confirmed)="onShareConfirmed()"
      (cancelled)="onShareCancelled()"
      (closed)="onShareModalClosed()"
    ></app-share-confirmation-modal>
    @if(isSearchEnabled()) {
    <div class="menu">
      <div class="search-container">
        <f-text-input
          class="search-box"
          uuid="awlds-search-pinned"
          type="text"
          placeholder="Search"
          start-icon-config='{"iconName": "search", "iconType": "fal"}'
          (inputChanged)="onInputChanged($event)"
          (inputFocused)="onInputFocused($event)"
          (inputBlur)="onInputBlur($event)"
        >
        </f-text-input>
        <f-button text="Search" variant="action" (buttonClicked)="onSearch()" />
      </div>
    </div>
    }

    <div class="menu">
      <f-overflow-menu
        class="mr-xl mb-24"
        [overflowItems]="productOverflowItems"
        [overflowText]="productMenuText"
        [overflowIconConfig]="overflowIconConfig"
        uuid="product-overflow-menu"
        is-icon-only="false"
        (overflowItemSelected)="onFilterSelected($event, 'product')"
      >
      </f-overflow-menu>

      <f-overflow-menu
        class="mr-xl"
        [overflowItems]="subscriptionStatus"
        [overflowText]="subscriptionStatusMenuText"
        [overflowIconConfig]="overflowIconConfig"
        uuid="subscription-overflow-menu"
        is-icon-only="false"
        (overflowItemSelected)="onFilterSelected($event, 'subscriptionType')"
      >
      </f-overflow-menu>

      <f-overflow-menu
        class="mr-xl"
        [overflowItems]="reportingTypes"
        [overflowText]="reportingTypeMenuText"
        [overflowIconConfig]="overflowIconConfig"
        uuid="reporting-type-overflow-menu"
        is-icon-only="false"
        (overflowItemSelected)="onFilterSelected($event, 'reportingType')"
      >
      </f-overflow-menu>

      <f-overflow-menu
        class="mr-xl"
        [overflowItems]="contentTypes"
        [overflowText]="contentTypeMenuText"
        [overflowIconConfig]="overflowIconConfig"
        uuid="content-type-overflow-menu"
        is-icon-only="false"
        (overflowItemSelected)="onFilterSelected($event, 'contentType')"
      >
      </f-overflow-menu>

      <f-overflow-menu
        class="mr-xl"
        [overflowItems]="sortOptions"
        [overflowText]="sortMenuText"
        [overflowIconConfig]="sortIconConfig"
        uuid="sort-overflow-menu"
        is-icon-only="false"
        (overflowItemSelected)="onFilterSelected($event, 'sort')"
      >
      </f-overflow-menu>
    </div>
    <div class="dashboards-table">
      <p class="subtitle">
        {{ itemCount }} item{{ itemCount !== 1 ? "s" : "" }}
      </p>
      <f-table auto-sort>
        <table role="table" aria-colcount="7">
          <caption class="screen-reader-text">
            This is a table containing all Reports and Dashboards available.
          </caption>
          <thead>
            <tr role="row">
              <th
                data-type="string"
                class="text-align-left w-15"
                role="columnheader"
              >
                Title
              </th>
              <th
                data-type="string"
                data-sortable
                class="text-align-left"
                role="columnheader"
              >
                Reporting type
              </th>
              <th
                data-type="string"
                data-sortable
                class="text-align-left"
                role="columnheader"
              >
                Content Type
              </th>
              <th
                data-type="string"
                data-sortable
                class="text-align-left"
                role="columnheader"
              >
                Owner
              </th>
              <th
                data-type="string"
                data-sortable
                class="text-align-left"
                role="columnheader"
              >
                Summary
              </th>
              <th
                data-type="string"
                data-sortable
                class="text-align-left"
                role="columnheader"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr role="row" *ngFor="let item of filteredContent; let i = index">
              <td role="cell">
                <f-link
                  text="{{ item.title }}"
                  (linkClicked)="onContentTitleClicked(item)"
                />
              </td>
              <td role="cell" class="text-wrap-nowrap">
                {{ item.reportType }}
              </td>
              <td role="cell" class="text-align-left">
                {{ item.contentType }}
              </td>
              <td role="cell" class="text-align-left">
                {{ getOwnerDisplay(item) }}
              </td>
              <td role="cell" class="text-align-left">
                {{ item.description }}
              </td>
              <td role="cell" class="text-align-left actions-col">
                <f-overflow-menu
                  class="actions-overflow"
                  variant="naked"
                  [overflowItems]="getActionMenuItems(item)"
                  [overflowIconConfig]="actionsIconConfig"
                  uuid="actions-overflow-menu-{{ item.contentId }}"
                  is-icon-only="true"
                  [attr.vertical-placement]="filteredContent.length <= 2 ? 'bottom' : (i >= filteredContent.length - 2 ? 'top' : 'bottom')"
                  (overflowItemSelected)="onOverflowItemClicked($event, item)"
                >
                </f-overflow-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </f-table>
    </div>
  </div>
  }
</div>
